export default __webpack_public_path__ + "8ec5edc50f23371741498f42d60c64b7.png";